export function getDefaultConfirmation({ checkout, email }) {
  if (checkout.sendEmailConfirmation) {
    return {
      title: 'Booking confirmed!',
      message: `You will receive an email confirmation shortly${
        email
          ? ` at 
      ${email}`
          : '.'
      }`,
    };
  } else {
    return {
      title: 'Booking confirmed!',
      message: '',
    };
  }
}
